import { useDialogStore } from "@/store/dialog"
import {
    startGameDialogueData,
    startGuideDialogueData,
    passWithoutSkillDialogueData,
    firstUseSkillDialogueData,
    randomSkillDialogueData,
    thirdSkillDialogueData,
    chooseSkillGuideDialogueData,
    useSkillGuideDialogueData,
} from "@/components/Dialog/data"
import { useGameStore } from "@/store/game"
import { useShareStore } from "@/store/share"
import { setGuideProgress, hasCompletedStage, GuideStage } from "@/utils/utils"
import { collect } from "@/utils/sdk"

export const useDialogue = () => {
    const { startDialog } = useDialogStore()
    const startGuideDialogue = (resolve: (value?: unknown) => void) => {
        if (hasCompletedStage(GuideStage.GUIDE_DIALOGUE)) {
            resolve()
            return
        }

        startDialog(startGuideDialogueData, () => {
            collect("first_watch_tutorial_initial", {})
            setGuideProgress(GuideStage.GUIDE_DIALOGUE)
            resolve()
        })
    }
    const startGameDialogue = () => {
        return new Promise((resolve) => {
            if (hasCompletedStage(GuideStage.START_DIALOGUE)) {
                startGuideDialogue(resolve)
                return
            }
            startDialog(startGameDialogueData, () => {
                setGuideProgress(GuideStage.START_DIALOGUE)
                startGuideDialogue(resolve)
            })
        })
    }

    const startChooseGuideDialogue = (callback: () => void) => {
        startDialog(chooseSkillGuideDialogueData, callback)
    }
    const startUseGuideDialogue = () => {
        startDialog(useSkillGuideDialogueData, () => {})
    }
    //  没有使用任何技能通关
    const passWithoutSkillDialogue = () => {
        startDialog(passWithoutSkillDialogueData, () => {})
    }

    const firstUseSkillDialogue = (callback: () => void) => {
        startDialog(firstUseSkillDialogueData, callback)
    }

    const randomSkillDialogue = (callback: () => void) => {
        const { usedSkillIndices } = useGameStore.getState()
        if (usedSkillIndices.length === 3) {
            startDialog(thirdSkillDialogueData, callback)
            return
        }
        const randomIndex = Math.floor(
            Math.random() * randomSkillDialogueData.length
        )
        startDialog([randomSkillDialogueData[randomIndex]], callback)
    }

    //出现分享弹窗时，出现对话
    const showShareDialogue = (callback?: () => void) => {
        const { dialogueData } = useShareStore.getState()
        startDialog(dialogueData, callback || (() => {}))
    }

    return {
        startGameDialogue,
        startGuideDialogue,
        passWithoutSkillDialogue,
        firstUseSkillDialogue,
        randomSkillDialogue,
        showShareDialogue,
        startChooseGuideDialogue,
        startUseGuideDialogue,
    }
}
